import axios from "../../axios";

const release = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.get('admin/log-pay-out/release' ,{
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid: uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default release;
